import type { DocumentoElectronico } from "@/shared/types/documento-electronico";
import type { CamposInutilizacionDE } from "../api/delete-documento-electronico";

/**
 * Construye los campos necesarios para inutilizar/borrar un Documento Electrónico
 */
export function buildCamposInutilizacionDE(
  de: DocumentoElectronico,
  motivoOtroEvento?: string
): CamposInutilizacionDE {
  return {
    CDC: de.cdc || "",
    DNumTim: de.timbrado || "",
    DEst: de.establecimiento || "",
    DPuntExp: de.puntoExpedicion || "",
    DNumIn: de.numeroDocumento || 0,
    DNumFin: de.numeroDocumento || 0,
    ITiDE: de.tipoDocumento || 1,
    MOtEve: motivoOtroEvento || "Anulación de documento"
  };
}